import React from "react";

import { ContainerBg } from "../../useGeneralStyles";
import Sales from "./components/Sales";

const Affiliate = (): React.ReactElement => {
  return (
    <ContainerBg>
      <Sales />
    </ContainerBg>
  );
};

export default Affiliate;
